import { useMemo } from "react";
import Slider from "components/Slider";
import { useUserContext } from "context/UserContext";
import { ProductWithRelations } from "Types";
import {MenuCard} from "components/MenuLayout";
import { getTranslation } from "dictionary";
import { useStylesContext } from "context/StylesContext";

interface Props {
  featuredProducts: ProductWithRelations[];
}
const MenuCarousel: React.FC<Props> = ({ featuredProducts }) => {
  const { language } = useUserContext();
  const { innerWidth } = useStylesContext().windowSize;

  const slides = useMemo(
    () =>
      featuredProducts?.map((featuredProduct) => {
        return (
          <div
            key={featuredProduct.id}
            id={featuredProduct.id.toString()}
            className="keen-slider__slide"
            style={{
              maxWidth: 420,
              minWidth: 300,
              minHeight: "100%",
            }}
          >
            <MenuCard
              key={featuredProduct.id}
              item={featuredProduct}
              cardType="carousel"
            />
          </div>
        );
      }),
    [featuredProducts]
  );

  const perViewSlides =
    innerWidth <= 460
      ? 1
      : innerWidth > 460 && innerWidth <= 640 
      ? 2
      : innerWidth > 640 && innerWidth < 768
      ? 3
      : 1;

  return (
    <section
      className="py-4 shadow-md scroll-my-20"
      id="featured"
    >
      <span className="cardTitle font-medium text-md text-center pb-4">
        {getTranslation("menu", "FEATURED", language)}
      </span>
      <Slider
        key={perViewSlides}
        slides={slides}
        perView={perViewSlides}
        spacing={10}
        type="dots"
      />
    </section>
  );
};

export default MenuCarousel;
